// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"916":"66cc1fec","962":"0996c757"}[chunkId] + ".css";
};